import ExcelIcon from './component.jsx'
export default ExcelIcon
